/**
 * @generated SignedSource<<806abff1e975947b3de40cefa8a41b7b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type multiGroupPicker_nativeIssueTable_MultiGroupPickerCell$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "multiGroupPicker_nativeIssueTable_MultiGroupPickerCell";
};
export type multiGroupPicker_nativeIssueTable_MultiGroupPickerCell$key = {
  readonly " $data"?: multiGroupPicker_nativeIssueTable_MultiGroupPickerCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"multiGroupPicker_nativeIssueTable_MultiGroupPickerCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "multiGroupPicker_nativeIssueTable_MultiGroupPickerCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef"
    }
  ],
  "type": "JiraMultipleGroupPickerField"
};

(node as any).hash = "7c440756aab477bb66df5feaffeda0d0";

export default node;
